import React, { useEffect, useMemo } from 'react'
import { Helmet } from 'react-helmet'
import { Grid, Segment } from 'semantic-ui-react'
import { Media, t } from 'shared'

const useTitle = (title?: string) => {
  const res = useMemo(() => title ?? t('hostname'), [title])
  return res
}

export const SingleColumnLayout: React.FC<{ title?: string }> = ({ children, title: title_ }) => {
  const title = useTitle(title_)
  useEffect(() => {
    try {
      window.scrollTo(0, 0)
    } catch (_) {}
  }, [])

  return (
    <Grid centered padded="horizontally">
      <Helmet>
        <title>{title}</title>
        <body className="single-column-layout" />
      </Helmet>

      <Grid.Row>
        <Grid.Column style={{ maxWidth: 500 }}>
          <Media lessThan="fiveHundred">{children}</Media>
          <Media greaterThanOrEqual="fiveHundred">
            <Segment>{children}</Segment>
          </Media>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}
